module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qdige2-2ebf31312028f7046eb2f34acf2c15d9.jpg";